<template>
   <transition>
     <div id="birthdayCard" v-if="isShowCard">
       <div class="topDiv">
         <img src="@/assets/cake.png" width="100%" alt="">
         <div class="topLeftDiv">
           <pt-icon type="icon-shengri" class="cakeIcon"></pt-icon>
           <div class="birthText">{{todayStr}}{{$t('baseVO.birthText')}}</div>
         </div>
         <div class="topRightDiv" @click="closeEvent">
           <pt-icon type="icon-guanbi" class="closeIcon"></pt-icon>
         </div>
       </div>
       <div class="memberDiv">
         <div v-for="(item) in birthList" class="birthGuy">
           <div class="imageDiv">
             <div class="hatIcon">
               <pt-icon type="icon-shengrimao"></pt-icon>
             </div>
             <a-avatar icon="user" :size="40" :src="getImageUrl(item.headimg)"></a-avatar>
           </div>
           <div class="guyName">{{item.userName}}</div>
         </div>
       </div>
     </div>
   </transition>
</template>

<script>
  import {getBirthDayEmployee} from '@/api/sys/user'
  export default {
    name: 'index',
    data(){
      return{
        isShowCard:false,
        birthList:[],
      }
    },
    mounted(){
      this.init();
    },
    computed:{
      todayStr(){
        let today = this.$moment().format('M月DD号')
        return today;
      }
    },
    methods:{
      getImageUrl(headimg){
        return this.$util.getFileUrl(headimg)
      },
      init(){
        getBirthDayEmployee().then(res=>{
          if(res.code == 1){
            this.birthList = res.data
            if(this.birthList && this.birthList.length > 0){
              this.isShowCard = true;
              setTimeout(()=>{
                this.isShowCard = false;
              },10000)
            }
          }
        })
      },
      closeEvent(){
        this.isShowCard = false
      }
    }
  }
</script>

<style scoped lang="less">
  .v-enter{
    opacity: 0;
    transform: translateX(100%);
  }
  .v-leave-to{
    opacity: 0;
    transform: translateX(100%);
    /*position: absolute;*/
  }
  .v-enter-active,.v-leave-active{
    transition: all 0.35s ease;
  }
  #birthdayCard{
    opacity: 1;
    width: 400px;
    z-index: 10;
    background: #FFFFFF;
    box-shadow: 0 14px 15px 0 rgba(0,0,0,0.14);
    border-radius: 20px;
    position: fixed;
    top: 70px;
    right: 20px;
    .topDiv{
      /*background-image: url('~@/assets/cake.png');*/
      /*background-color: #FFFFFF;*/
      background-size: contain;
      background-repeat: round;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      background-size: contain;
      background-repeat: round;
      height: 90px;
      background-position-y: top;
      img{
        position: absolute;
        top:-12px;
      }
      .topLeftDiv{
        margin-left: 16px;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 40px;
        z-index: 99;
      }
      .topRightDiv{
        margin-right: 10px;
        margin-bottom: 40px;
        z-index: 99;
      }
      .cakeIcon{
        font-size: 30px;
      }
      .birthText{
        font-size: 14px;
        color: #FFFFFF;
        font-weight: bold;
        margin-left: 10px;
      }
      .closeIcon{
        cursor: pointer;
        color: #FFFFFF;
        font-size: 16px;
      }
    }
    .memberDiv{
      background-color: #ffffff;
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 10px 15px;
      margin-top: -30px;
      border-radius: 20px;
      .birthGuy{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 5px 16px;
        .imageDiv{
          position: relative;
        }
        .hatIcon{
          position: absolute;
          top: -8px;
          right: -6px;
          font-size: 14px;
        }
        .guyName{
          font-size: 14px;
          color: #4D4D4D;
        }
      }
    }
  }
</style>